module.exports = __webpack_public_path__ + "img/telemetry_light.d0302ce4.svg";